import React from 'react';
import { PropTypes } from 'prop-types';
import { compose, pure } from 'recompose';

import CloseButton from 'components/ResponsiveModal/CloseButton';

const enhance = compose(pure);

const ResponsiveModal = ({
  opened,
  header,
  footer,
  className,
  children,
  content,
  setChildrenRef,
  refProperty,
  close,
  listenerElement,
  disableBlur,
  enableBlur,
  handleFocus,
  handleBlur,
  alignRight,
}) => {
  const componentProps = {
    [refProperty]: setChildrenRef,
    onFocus: handleFocus,
    onBlur: handleBlur,
  };
  const listenerProps = { listenerElement, close };

  return (
    <div className={className}>
      {React.cloneElement(children, componentProps)}
      {!!opened && content && (
        <div
          className="floating"
          onMouseEnter={disableBlur}
          onMouseLeave={enableBlur}
        >
          <div className="header">
            <CloseButton onClick={close} />
            {header}
          </div>
          <div className="content">
            {React.cloneElement(content, listenerProps)}
          </div>
          {!!footer && <div className="footer">{footer}</div>}
        </div>
      )}
    </div>
  );
};

ResponsiveModal.propTypes = {
  opened: PropTypes.bool,
  header: PropTypes.oneOfType([PropTypes.node, PropTypes.instanceOf(Element)]),
  footer: PropTypes.oneOfType([PropTypes.node, PropTypes.instanceOf(Element)]),
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.instanceOf(Element),
  ]),
  content: PropTypes.oneOfType([PropTypes.node, PropTypes.instanceOf(Element)]),
  className: PropTypes.string,
  refProperty: PropTypes.string,
  setChildrenRef: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  listenerElement: PropTypes.instanceOf(Element),
  disableBlur: PropTypes.func.isRequired,
  enableBlur: PropTypes.func.isRequired,
  handleFocus: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  alignRight: PropTypes.bool,
};

ResponsiveModal.defaultProps = {
  opened: false,
  header: null,
  footer: null,
  children: null,
  content: null,
  listenerElement: null,
  className: '',
  refProperty: 'ref',
};

export default enhance(ResponsiveModal);
